import React from 'react';
import SVGLoader from './SVGLoader';

const PhoneIcon = props => {
  const { width, height, viewboxWidth, viewboxHeight } = props;

  return (
    <SVGLoader
      {...props}
      width={width || 10}
      height={height || 14}
      viewboxWidth={viewboxWidth || 14}
      viewboxHeight={viewboxHeight || 12}
    >
      <g id="Page-1" stroke="none" strokeWidth="1" fillRule="evenodd">
        <g id="filter-04" transform="translate(-21.000000, -167.000000)">
          <path
            d="M26.9492419,177.71316 C28.0500387,176.966886 28.6974819,176.792649 30.1811459,177.816909 C31.8420739,178.963627 32.1497219,180.277773 29.3581475,181.400125 C23.8938595,180.949224 19.2827875,172.962637 21.6244195,168.004989 C23.9921155,166.148477 24.9765155,167.072005 25.1390275,169.083864 C25.2843515,170.880856 24.8096387,171.35444 23.6130307,171.934792 C23.7776307,174.106712 25.1503651,176.484616 26.9492387,177.713176 L26.9492419,177.71316 Z"
            id="Path"
          ></path>
        </g>
      </g>
    </SVGLoader>
  );
};

export default PhoneIcon;
